import { render, staticRenderFns } from "./MicrophonePushRTMP.vue?vue&type=template&id=87ce2322&scoped=true"
import script from "./MicrophonePushRTMP.vue?vue&type=script&lang=js"
export * from "./MicrophonePushRTMP.vue?vue&type=script&lang=js"
import style0 from "./MicrophonePushRTMP.vue?vue&type=style&index=0&id=87ce2322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ce2322",
  null
  
)

export default component.exports